export default __webpack_public_path__ + "../staticImages/winefinder-sprite-occasion_einfach_so.png";